import React from "react";

import VideoCardPlaylist from "../../../../components/VideoCardPlaylist";
import ReorderPlaylistComponent from "../../../../components/Playlist/ReorderPlaylistComponent";

export const VideoGrid = ({
  videos = [],
  playlistId,
  playlist,
  savedVideos = [],
  onDelete,
  onSaveUnsave,
  onReorder,
  isReordering = false,
  subscriptionStatus,
}) => {
  if (!videos || videos.length === 0) {
    return <div className="text-center p-3">No videos in this playlist.</div>;
  }

  const displayVideos = Array.isArray(videos) ? videos : [];

  return (
    <div className="p-0">
      {isReordering ? (
        <ReorderPlaylistComponent
          items={displayVideos.map((video, i) => ({ ...video, id: video._id, position: i }))}
          onReorder={(next, updates) => onReorder(next, updates)}
          renderItem={(video) => (
            <div className="mb-2">
              <VideoCardPlaylist
                video={video}
                playlistId={playlistId}
                isLiked={savedVideos.includes(video._id)}
                viewType={playlist?.type}
                fld={playlist}
                savedVideos={savedVideos}
                showAddToPlaylist={false}
                handleSaveUnsave={onSaveUnsave}
                subscriptionStatus={subscriptionStatus}
                handleDeleteVideo={onDelete}
                isReordering={isReordering}
              />
            </div>
          )}
          gap={8}
        />
      ) : (
        <div className="c-video_list-playlist">
          {displayVideos.map((video, index) => (
            <div key={`${video._id}-${index}`} className="mb-2">
              <VideoCardPlaylist
                video={video}
                playlistId={playlistId}
                isLiked={savedVideos.includes(video._id)}
                viewType={playlist?.type}
                fld={playlist}
                savedVideos={savedVideos}
                showAddToPlaylist={false}
                handleSaveUnsave={onSaveUnsave}
                subscriptionStatus={subscriptionStatus}
                handleDeleteVideo={onDelete}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
